// extracted by mini-css-extract-plugin
module.exports =  {"alert":"URQPS2ZQT9H10mWOCLDA"};